import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFetchingDataFromBank = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 320,
	height: 96,
	viewBox: "0 0 320 96",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 64,
			y: 16,
			width: 192,
			height: 64,
			rx: 32,
			stroke: "#1D1D1D",
			strokeOpacity: .1,
			strokeWidth: 1.6,
			strokeDasharray: "8 8"
		}),
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_4699_65544)",
			children: [
				/* @__PURE__ */ _jsx("circle", {
					cx: 48,
					cy: 48,
					r: 48,
					fill: "#FEFEFE"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 48,
					cy: 48,
					r: 47.5,
					stroke: "#1D1D1D",
					strokeOpacity: .1
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M47.7715 42.5895V48.179C57.0522 48.179 57.0522 42.5895 66.3329 42.5895V37C57.0522 37 57.0522 42.5895 47.7715 42.5895Z",
					fill: "#2047F4"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M47.7715 53.5573V59.1468C57.0522 59.1468 57.0522 53.5573 66.3329 53.5573V47.9678C57.0522 47.9678 57.0522 53.5573 47.7715 53.5573Z",
					fill: "#2047F4"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M29 42.5895V48.179C38.3862 48.179 38.3862 42.5895 47.7723 42.5895V37C38.3862 37 38.3862 42.5895 29 42.5895Z",
					fill: "#2047F4"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M29 53.5573V59.1468C38.3862 59.1468 38.3862 53.5573 47.7723 53.5573V47.9678C38.3862 47.9678 38.3862 53.5573 29 53.5573Z",
					fill: "#2047F4"
				})
			]
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 144,
			y: 32,
			width: 32,
			height: 32,
			rx: 16,
			fill: "#4E8B43"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M150 43C150 42.7868 150.08 42.5726 150.242 42.4101L153.936 38.9859C154.341 38.6098 154.999 38.8968 154.999 39.4488L154.999 41.996L159.999 41.996C160.132 41.9941 160.263 42.0186 160.386 42.068C160.509 42.1175 160.621 42.1908 160.716 42.2839C160.81 42.3769 160.885 42.4878 160.936 42.6101C160.987 42.7324 161.014 42.8636 161.014 42.9961C161.014 43.1287 160.987 43.2599 160.936 43.3821C160.885 43.5044 160.81 43.6153 160.716 43.7084C160.621 43.8014 160.509 43.8748 160.386 43.9242C160.263 43.9736 160.132 43.9981 159.999 43.9962L154.999 43.9962L154.999 46.5493C154.999 47.1023 154.341 47.3893 153.936 47.0122L150.242 43.588C150.08 43.4255 150 43.2133 150 43ZM150.998 52.9973C150.998 52.4452 151.446 51.9972 151.998 51.9972C152.55 51.9972 152.998 52.4452 152.998 52.9973C152.998 53.5494 152.55 53.9974 151.998 53.9974C151.446 53.9974 150.998 53.5494 150.998 52.9973ZM154.999 52.9973C154.999 52.4452 155.447 51.9972 155.999 51.9972C156.551 51.9972 156.999 52.4452 156.999 52.9973C156.999 53.5494 156.551 53.9974 155.999 53.9974C155.447 53.9974 154.999 53.5494 154.999 52.9973ZM158.985 52.9817C158.99 52.7168 159.099 52.4643 159.289 52.2797C159.479 52.0952 159.734 51.9935 159.999 51.9972L165 51.9972L165 49.45C165 48.8979 165.657 48.611 166.062 48.9871L169.756 52.4113C170.081 52.7363 170.081 53.2641 169.756 53.5892L166.062 57.0134C165.657 57.3904 165 57.1035 165 56.5504L165 53.9974L159.999 53.9974C159.865 53.9992 159.733 53.9742 159.609 53.9238C159.485 53.8734 159.372 53.7986 159.278 53.7039C159.183 53.6091 159.108 53.4964 159.058 53.3724C159.008 53.2483 158.983 53.1155 158.985 52.9817ZM163 42.9961C163 42.4441 163.448 41.996 164 41.996C164.552 41.996 165 42.4441 165 42.9961C165 43.5482 164.552 43.9962 164 43.9962C163.448 43.9962 163 43.5482 163 42.9961ZM167 42.9961C167 42.4441 167.448 41.996 168 41.996C168.552 41.996 169 42.4441 169 42.9961C169 43.5482 168.552 43.9962 168 43.9962C167.448 43.9962 167 43.5482 167 42.9961Z",
			fill: "#FDFDFD",
			fillOpacity: .92
		}),
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip1_4699_65544)",
			children: [
				/* @__PURE__ */ _jsx("circle", {
					cx: 272,
					cy: 48,
					r: 48,
					fill: "#FEFEFE"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 272,
					cy: 48,
					r: 47.3333,
					stroke: "#1D1D1D",
					strokeOpacity: .1,
					strokeWidth: 1.33333
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M263.8 57.0841C263.444 57.0841 263.133 56.9563 262.867 56.7008C262.6 56.4452 262.467 56.1175 262.467 55.7175V46.9841C262.467 46.673 262.606 46.3841 262.883 46.1175C263.161 45.8508 263.467 45.7175 263.8 45.7175C264.178 45.7175 264.494 45.8508 264.75 46.1175C265.006 46.3841 265.133 46.6841 265.133 47.0175V55.7508C265.133 56.1286 265 56.4452 264.733 56.7008C264.467 56.9563 264.156 57.0841 263.8 57.0841ZM272.167 57.0841C271.789 57.0841 271.472 56.9563 271.217 56.7008C270.961 56.4452 270.833 56.1175 270.833 55.7175V46.9841C270.833 46.673 270.967 46.3841 271.233 46.1175C271.5 45.8508 271.8 45.7175 272.133 45.7175C272.489 45.7175 272.8 45.8508 273.067 46.1175C273.333 46.3841 273.467 46.6841 273.467 47.0175V55.7508C273.467 56.1286 273.333 56.4452 273.067 56.7008C272.8 56.9563 272.5 57.0841 272.167 57.0841ZM259.5 61.3508C259.1 61.3508 258.75 61.1952 258.45 60.8841C258.15 60.573 258 60.2175 258 59.8175C258 59.3952 258.144 59.0397 258.433 58.7508C258.722 58.4619 259.089 58.3175 259.533 58.3175H284.533C284.911 58.3175 285.256 58.4675 285.567 58.7675C285.878 59.0675 286.033 59.4175 286.033 59.8175C286.033 60.2397 285.883 60.6008 285.583 60.9008C285.283 61.2008 284.922 61.3508 284.5 61.3508H259.5ZM280.2 57.0841C279.844 57.0841 279.533 56.9563 279.267 56.7008C279 56.4452 278.867 56.1175 278.867 55.7175V46.9841C278.867 46.673 279.006 46.3841 279.283 46.1175C279.561 45.8508 279.867 45.7175 280.2 45.7175C280.578 45.7175 280.894 45.8508 281.15 46.1175C281.406 46.3841 281.533 46.6841 281.533 47.0175V55.7508C281.533 56.1286 281.4 56.4452 281.133 56.7008C280.867 56.9563 280.556 57.0841 280.2 57.0841ZM273.5 34.3175L284.6 40.6508C285.022 40.8952 285.367 41.2119 285.633 41.6008C285.9 41.9897 286.033 42.4063 286.033 42.8508C286.033 43.3397 285.839 43.7341 285.45 44.0341C285.061 44.3341 284.611 44.4841 284.1 44.4841H259.867C259.356 44.4841 258.917 44.323 258.55 44.0008C258.183 43.6786 258 43.2841 258 42.8175C258 42.3508 258.139 41.9341 258.417 41.5675C258.694 41.2008 259.056 40.8952 259.5 40.6508L270.5 34.3175C270.989 34.1175 271.489 34.0119 272 34.0008C272.511 33.9897 273.011 34.0952 273.5 34.3175Z",
					fill: "#1D1D1D",
					fillOpacity: .84
				})
			]
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_4699_65544",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 96,
				height: 96,
				fill: "white"
			})
		}), /* @__PURE__ */ _jsx("clipPath", {
			id: "clip1_4699_65544",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 96,
				height: 96,
				fill: "white",
				transform: "translate(224)"
			})
		})] })
	]
});
export default SvgFetchingDataFromBank;
